import { Alert } from "@pepdirect/v3/ui/Alert";
import styled from "styled-components";

export const StyledCheckboxContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

export const StyledLabel = styled.label`
  display: flex;
  width: 100%;
  min-height: 20px;
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 10px;

  div:first-child {
    margin-right: 11px;
  }
`;

export const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
`;

export const StyledAlert = styled(Alert)`
  margin-top: 16px;
`;
